import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import * as Sentry from "@sentry/react";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/semantic-compat.css";
import "./App.css";

// Off on the dev server (and so in mocked E2E). Route errors reach Sentry
// through ErrorPage, the router's errorElement.
Sentry.init({
  enabled: !import.meta.env.DEV,
  dsn:
    import.meta.env.VITE_SENTRY_DSN ||
    "https://019940d36ee2e0284bc475b31f7c12b0@o4507731883655168.ingest.de.sentry.io/4507731885817936",
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [Sentry.browserTracingIntegration()],
  // Trace every page load: traffic is low enough (D7).
  tracesSampleRate: 1.0,
  // Backends that get the sentry-trace/baggage headers.
  tracePropagationTargets: [
    /^https:\/\/trialtools\.clearlysimpler\.co\.uk/,
    /^https:\/\/tools\.parishdashboards\.org\.uk/,
  ],
});

// index.html has already shown the "browser too old" message. The router
// starts loading as soon as it's created, so only import it otherwise.
if (!document.getElementById("unsupported"))
  import("./routes").then(({ router }) =>
    createRoot(document.getElementById("root")!).render(
      <RouterProvider router={router} />,
    ),
  );
